export enum WinnersEvent {
  WINNERS_SHARE_WIN = 'WinnersShareMyBigWinEvent',
  WINNERS_COPY_MY_BIG_WIN_URL = 'WinnersCopyMyBigWinURLEvent',
  WINNERS_SEE_ALL_WINS = 'WinnersSeeAllMyBigWinsEvent',
  WINNERS_PAGINATE_WINS = 'WinnersPaginateMyBigWinsEvent',
}
